module.exports = __webpack_public_path__ + "img/report.4d107969.png";